import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import MarkdownRenderer from '../../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import { PAGES_URLS } from '../../../../../lib/constants/routes';
import { STRAPI_URL } from '../../../../../lib/constants/url';
import { FoerderProgrammProps } from '../../../../../lib/types/types';

// import Schemas

import FoerderProgrammSchema from 'src/lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
const FR_P = FoerderProgrammSchema.attributes;

const FoerderProgrammGrid: FC<FoerderProgrammProps> = ({ data }) => {
	const navigate = useNavigate();

	return (
		<>
			<Grid container spacing={5} columns={3}>
				{(data || []).map((ele, i) => (
					<Grid xs={3} sm={1.5} md={1} key={i}>
						<Card
							raised
							sx={{ maxWidth: '25rem' }}
							onClick={() => navigate(`${PAGES_URLS.FoerderProgrammDetails}`, { state: { id: get(ele, 'id', -1) } })}
						>
							<CardActionArea component='div'>
								<CardMedia
									component={'img'}
									height={265}
									image={`${STRAPI_URL}${get(ele, FR_P.Medien_Downloads_Programmbild.path + '.attributes.url')}`}
									alt={`Förderprogramm-logo-${get(ele, FR_P.Medien_Downloads_Programmbild.path + '.attributes.name')}`}
								/>
								<CardContent>
									<Typography gutterBottom variant='h6' component={'div'} sx={{ mb: '1rem', fontWeight: 600 }}>
										{get(ele, 'attributes.Allgemein_Titel_Deutsch')}
									</Typography>
									<Typography
										variant='body1'
										color='text.secondary'
										component={'div'}
										sx={{
											height: '6.5rem', // Adjust the height to match 5 lines of text
											lineHeight: '1.1rem', // Line height for body2
											overflow: 'hidden',
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: 5,
										}}
									>
										<MarkdownRenderer markdown={get(ele, FR_P.Allgemein_Kurzbeschreibung.path, '')} />
									</Typography>
								</CardContent>
								<CardActions>
									<Button endIcon={<KeyboardArrowRightIcon />}>Mehr erfahren</Button>
								</CardActions>
							</CardActionArea>
						</Card>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default FoerderProgrammGrid;
